import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import * as S from './Forms.styled';
import { ProfileEditContext } from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/CLIENTVIEW/components/ClientProfile/components/ProfileEditContext';

import { RootState } from 'redux/store';

interface AddEntryFooterProps {
    title: string;
    addLabel: string;
    addAnotherLabel?: string;
    hasEntries?: boolean;
    onClick: () => void;
    /** Assessment additional-details uses a smaller section title instead of FooterTitle. */
    titleAsSection?: boolean;
}

const AddEntryFooter = ({
    title,
    addLabel,
    addAnotherLabel,
    hasEntries = false,
    onClick,
    titleAsSection = false,
}: AddEntryFooterProps) => {
    const profileEdit = useContext(ProfileEditContext);
    const { t } = useTranslation();
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const inProfileEdit = Boolean(profileEdit?.active);
    const buttonLabel = inProfileEdit
        ? hasEntries && addAnotherLabel
            ? addAnotherLabel
            : addLabel
        : t('add', { lng: language });

    return (
        <S.Footer data-form-add-entry={inProfileEdit ? '' : undefined}>
            {!inProfileEdit &&
                (titleAsSection ? (
                    <S.Title style={{ fontSize: '20px', marginBottom: '0px' }}>{title}</S.Title>
                ) : (
                    <S.FooterTitle>{title}</S.FooterTitle>
                ))}
            <div>
                <S.FooterButton type="button" onClick={onClick}>
                    {buttonLabel}
                </S.FooterButton>
            </div>
        </S.Footer>
    );
};

export default AddEntryFooter;
